import type { Pair } from './api/GetPersonaPair';

// The Tutor is shown to the learner only for an enabled, synced pair
export const isTutorPairReady = (pair: Pair | null) =>
  pair !== null &&
  !pair.disabled &&
  (pair.syncStatus === 'synced' || !!pair.synced);
